import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { OAuthData } from '../../../auth/models/oauthdata.model';
import { BusinessTransactionWorkQueueDetailModel } from '../../../shared/models/business-transaction/business-transaction-work-queue-detail-model';
import { WIPStatusType } from '../../../wip/models/enums/w-i-p-status-type.enum';

@Component({
    selector: 'my-assignments',
    templateUrl: './my-assignments.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MyAssignmentsComponent implements OnInit {
    @Input() masterDropdownList: any[];
    @Input() personalQueueData: BusinessTransactionWorkQueueDetailModel[];
    @Input() user: OAuthData;
    @Output() onHold = new EventEmitter<BusinessTransactionWorkQueueDetailModel>();
    @Output() onRedirect = new EventEmitter<BusinessTransactionWorkQueueDetailModel>();
    @Output() onRemove = new EventEmitter<BusinessTransactionWorkQueueDetailModel>();
    @Output() onUnassign = new EventEmitter<BusinessTransactionWorkQueueDetailModel>();

    @ViewChild('myAssignmentTable') myAssignmentTable: Table;

    public wipStatuses: WIPStatusType = new WIPStatusType();

    constructor() { }

    ngOnInit() {}

    public holdTransaction(transactionId: number) {
        this.onHold.emit(this.findBusinessTransaction(transactionId));
    }

    public myAssignmentsCustomSort(event, personalQueueData) {
        if (event.field == 'displayUpdatedDate') {
            this.onDateTimeGenericSort(event, personalQueueData);
        } else {
            this.myAssignmentTable.customSort = false;
            this.myAssignmentTable.sortSingle();
            this.myAssignmentTable.customSort = true;
        }
    }

    public redirectToMyTransaction(businessTransaction: BusinessTransactionWorkQueueDetailModel) {
        this.onRedirect.emit(businessTransaction);
    }

    public removeTransaction(transactionId: number) {
        this.onRemove.emit(this.findBusinessTransaction(transactionId));
    }

    public unassignTransaction(transactionId: number) {
        this.onUnassign.emit(this.findBusinessTransaction(transactionId));
    }

    private findBusinessTransaction(transactionId: number): BusinessTransactionWorkQueueDetailModel {
        return this.personalQueueData.find(transaction => +transaction.transactionId === transactionId);
    }

    private onDateTimeGenericSort(event, data) {
        const comparer = (a, b): number => {
            let result = -1;
            if (a.updatedDate > b.updatedDate) {
                result = 1;
            }
            return result * event.order;
        };

        data.sort(comparer);
    }
}
